import { BASE_URL } from "../api_const";


export const SELL_EXISTING_PROJECT_BASE_URL = BASE_URL + "/services/sell-existing-project"
export const ALL_SELL_EXISTING_PROJECT = SELL_EXISTING_PROJECT_BASE_URL + "/all"
export const SELL_EXISTING_PROJECT_DETAILS_BY_ID = SELL_EXISTING_PROJECT_BASE_URL 

